import React from 'react'; 
import './companyConversationCard.css'
import { shopIcon, locationIcon, chefHatIcon } from '../../../../utils/icons';
import { Link } from 'react-router-dom';
import useSendProfileToCompany from '../../../../hooks/useSendProfileToCompany';
import SignedImage from '../../SignedImage/SignedImage';

const CompanyConversationCard = ({ data }) => {
 
  // Check for null/undefined data
  if (!data) {
    return null; 
  }

  // Check for required nested properties
  if (!data.restaurantUser) {
    return null; 
  }

  if (!data.restaurantUser.restaurant) {
    return null; // Return null instead of error message
  }

  // Safely access nested properties with fallbacks
  const imageSrc = data.restaurantUser.restaurant.profileImageUrl || '/logo192.png';
  const restaurantName = data.restaurantUser.restaurant.name || 'Restaurante no especificado';
  const restaurantFormat = data.restaurantUser.restaurant.format || 'No especificado';
  const region = data.restaurantUser.restaurant.region || 'No especificado';
  const comuna = data.restaurantUser.restaurant.comuna || 'No especificado';
  const specialty = data.restaurantUser.restaurant.specialty || 'No especificado';
  const description = data.restaurantUser.restaurant.description || 'Sin descripción';
  const restaurantId = data.restaurantUser.restaurant.id;

  const formatLocation = (region, comuna) => (
    comuna === "No hay" ? region : `${region}, ${comuna}`
  );

  return (
    <div className="company-conversation-card__container">
      <div className="company-conversation-card__image-container">
        <SignedImage
          src={imageSrc}
          alt={`Logo de ${restaurantName}`}
          fallbackSrc="/logo192.png"
          showLoading={false}
          className="company-conversation-card__image"
          onError={() => {
            console.warn('CompanyConversationCard - Image failed to load:', imageSrc);
          }}
        />
      </div>
      <div className="company-conversation-card__description">
        <h3>{restaurantName}</h3>
        <div>
          <div className="company-conversation-card__icon-title-container">
            {shopIcon}
            <div className="company-conversation-card__info-container">
              <p><strong>Establecimiento:</strong></p> 
              <p>{restaurantFormat}</p>
            </div>
          </div>
          <div className="company-conversation-card__icon-title-container"> 
            {locationIcon}
            <div className="company-conversation-card__info-container">
              <p><strong>Ubicación:</strong></p> 
              <p>{formatLocation(region, comuna)}</p>
            </div> 
          </div>
          <div className="company-conversation-card__icon-title-container">
            {chefHatIcon}
            <div className="company-conversation-card__info-container">
              <p><strong>Especialidad:</strong></p>
              <p>{specialty}</p>
            </div>
          </div>
        </div>
        <div className="company-conversation-card__description-footer">
          <p>{description}</p>
        </div>
      </div>
      <div className="company-conversation-card__buttons">
        <Link to={`/empresas/${restaurantId}`}>
          <button className="company-conversation-card__button">Empresa</button>       
        </Link>
        <Link to={`/panel-empleado/inbox-empleado/${data.id}/${data.restaurantUserId}`}>
              <button className="company-conversation-card__button">Chat</button>
        </Link>
      </div>
    </div>
  );
};

export default CompanyConversationCard;
